import { Navigate, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CareLayout from './components/CareLayout';
import ProtectedRoute from './components/ProtectedRoute';
import PublicOnlyRoute from './components/PublicOnlyRoute';
import RoleRoute from './components/RoleRoute';
import CareHome from './pages/CareHome';
import Doctors from './pages/Doctors';
import Login from './pages/Login';
import Patients from './pages/Patients';
import Pharmacy from './pages/Pharmacy';
import StaffAccess from './pages/StaffAccess';
import SupportLogs from './pages/SupportLogs';
import Transactions from './pages/Transactions';
import Profile from './pages/Profile';
import QrManage from './pages/QrManage';
import Unauthorized from './pages/Unauthorized';
import { STAFF_ACCESS_ROLES } from './api/auth';
import { restoreSession } from './store/authSlice';

function App() {
  const dispatch = useDispatch();
  const { token, isAuthChecked } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(restoreSession());
  }, [dispatch]);

  if (!isAuthChecked) {
    return <div className="care-auth-loading">Restoring session…</div>;
  }

  return (
    <Routes>
      <Route element={<PublicOnlyRoute />}>
        <Route path="/login" element={<Login />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<CareLayout />}>
          <Route path="/" element={<CareHome />} />
          <Route path="/doctors" element={<Doctors />} />
          <Route path="/patients" element={<Patients />} />
          <Route path="/pharmacy" element={<Pharmacy />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/qr-manage" element={<QrManage />} />
          <Route path="/support-logs" element={<SupportLogs />} />
          <Route path="/profile" element={<Profile />} />
          <Route element={<RoleRoute allowedRoles={STAFF_ACCESS_ROLES} />}>
            <Route path="/staff-access" element={<StaffAccess />} />
          </Route>
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to={token ? '/' : '/login'} replace />} />
    </Routes>
  );
}

export default App;
